<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-ASSETS" :defaultOpen="defaultOpen">

    <div class="control">
      <div class="control">
        <vue-dropzone
          ref="vueDropzonePimProduct"
          id="vueDropzonePimProduct"
          url="fileProcessing/upload?preset=pimProduct"
          :formDataAppend="[{ extRef: product.extRef }]"
          :thumbnailWidth="100"
          :thumbnailHeight="100"
          acceptedFiles=".jpg,.jpeg,.png,.gif"
          dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Produktbild hochladen"
          v-on:vdropzone-removed-file="dzRemoveFile"
          v-on:vdropzone-success="dzSuccess"
        >
        </vue-dropzone>
      </div>
    </div>

    <draggable
      tag="div"
      v-model="product.assets"
      handle=".dragHandler"
      @end="onDragEnd"
      class="assetsContainer is-clearfix list-group"
      v-if="product && product.assets && product.assets.length > 0"
    >
      <div
        v-for="(asset, index) in product.assets"
        :class="[
          'assetWrapper list-group-item',
          { isActive: asset.isActive },
          { isArchived: asset.isArchived },
        ]"
        :key="asset.id"
      >
        <div
          class="asset"
          v-lazy:background-image="assetGetUrl(asset)"
        ></div>

        <div class="overlay"></div>

        <div class="dragHandler">
          <span class="button is-single is-small">
            <i class="icon-ak-move"></i>
          </span>
        </div>

        <div class="actions">
          <a
            :href="assetGetUrl(asset, false)"
            :download="asset.asset.filename"
            class="button is-single is-small downloadLink"
            title="download"
            v-if="asset.asset.origin == NULL"
          >
            <span class="icon is-small"
              ><i class="fa icon-ak-download"></i
            ></span>
          </a>

          <template v-if="!asset.isArchived">
            <button
              :class="['button is-single is-small']"
              title="archivieren"
              @click.prevent="assetArchive(asset, index)"
            >
              <span class="icon is-small"
                ><i class="fa fa-archive"></i
              ></span>
            </button>
          </template>

          <template v-else>
            <button
              :class="['button is-single is-small is-success']"
              title="wiederherstellen"
              @click.prevent="assetArchive(asset, index)"
            >
              <span class="icon is-small"
                ><i class="fa fa-undo"></i
              ></span>
            </button>

            <pop-confirm
              :content="$t('PIM-PRODUCT-CONFIRMATION-DELETE_ASSET')"
              icon="question-circle-o"
              cancel-text="abbrechen"
              :on-ok="() => assetDelete(index)"
            >
              <button
                :class="['button is-single is-small is-danger']"
                title="löschen"
              >
                <span class="icon is-small"
                  ><i class="fa fa-trash-o"></i
                ></span>
              </button>
            </pop-confirm>
          </template>
        </div>

        <div class="assetOrigin">
          <template
            v-if="
              typeof asset.asset.origin != 'undefined' &&
              asset.asset.origin != null
            "
          >
            <lang
              :labelKey="
                'PIM-PRODUCT-PIM-' + asset.asset.origin + labelSuffix
              "
            ></lang>
          </template>
        </div>

        <div style="padding: 0 4px 4px 4px;">
           <input 
             type="text"
             class="input is-small" 
             style="font-size: 10px; height: 22px; padding: 2px 4px;" 
             placeholder="Alt-Text (SEO)..." 
             title="Alt Text"
             :value="asset.altText" 
             @input="$set(asset, 'altText', $event.target.value)" 
           />
        </div>

        <div class="assetActive">
          <p-check
            class="p-icon p-smooth p-plain"
            v-model="asset.isActive"
            @click.native="assetSetActive(asset)"
          >
            <i slot="extra" class="icon icon-ak-speichern"></i>
            Hauptbild {{ asset.sortorder }}
          </p-check>
        </div>
      </div>
    </draggable>

  </collapsible-section>
</template>

<script>
import Vue from "vue";
import vue2Dropzone from "../../utils/dropzoneWrapper";
import draggable from "vuedraggable";
import PrettyCheckbox from "pretty-checkbox-vue";
Vue.use(PrettyCheckbox);

import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionAssets",

  components: {
    vueDropzone: vue2Dropzone,
    draggable,
    CollapsibleSection,
  },

  props: {
    product: { type: Object, required: true },
    pharmacy: { type: Object, default: null },
    labelSuffix: { type: String, default: "" },
    defaultOpen: { type: Boolean, default: false },
  },

  methods: {
    assetGetUrl(asset, thumb = true) {
      if (!asset) {
        return "";
      }
      if (thumb && asset.thumbUrl && asset.thumbUrl != "") {
        return asset.thumbUrl;
      } else {
        return asset.url;
      }
    },

    assetArchive(asset, index) {
      this.$set(this.product.assets[index], "isArchived", !asset.isArchived);
    },

    assetDelete(index) {
      this.product.assets.splice(index, 1);
      this.product.assets.forEach((a, i) => {
        a.sortorder = i;
      });
    },

    assetSetActive(asset) {
      this.product.assets.forEach((a) => {
        a.isActive = false;
      });
      asset.isActive = true;
    },

    onDragEnd() {
      let index = 0;
      this.product.assets.forEach((p) => {
        p.sortorder = index;
        index++;
      });
    },

    dzRemoveFile() {
      // placeholder — dropzone remove handler
    },

    dzSuccess(file) {
      var result = JSON.parse(file.xhr.response);

      this.product.assets.forEach((a, index) => {
        a.isActive = false;
        a.sortorder = index + 2;
      });

      this.product.assets.unshift({
        url: result.url ? result.url : null,
        thumbUrl: result.thumbUrl ? result.thumbUrl : null,
        sortorder: 1,
        isActive: true,
        pimProduct: this.product.id,
        asset: {
          filename: result.fileName,
          path: result.dir,
          uploadFilename: file.name,
        },
      });

      this.$refs["vueDropzonePimProduct"].$children[0].removeFile(file);
    },
  },
};
</script>

<style lang="scss">
@import "~pretty-checkbox/src/pretty-checkbox.scss";
</style>

<style scoped lang="scss">
@import "~../../../assets/css/variables.scss";

.assetsContainer {
  margin: 0 0 20px 0;
  padding: 5px;
  background-color: #f1f1f1;

  display: flex;
  flex-wrap: wrap;

  .assetWrapper {
    position: relative;
    background-color: #f5f5f5;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 130px;
    height: auto;
    margin: 5px;
    border: 1px solid #eee;
    border-radius: 3px;
    overflow: hidden;
    padding: 0;
    transition: all 0.3s ease;

    &:hover {
      border-color: #ddd;
    }

    .asset {
      position: relative;
      background-color: #fff;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: contain;
      width: 100%;
      height: 85px;

      &[lazy="loading"] {
        background-size: 30% !important;
      }
    }
  }
}

.assetsContainer .assetWrapper .assetOrigin {
  font-size: 9px;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  height: 18px;
}

.assetWrapper .dragHandler {
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
  width: 21px;
  height: 21px;
  cursor: auto;
  display: none;
}

.assetWrapper .dragHandler .button {
  cursor: move;
  border: none;
}

.assetsContainer .assetWrapper:hover .dragHandler {
  display: block;
}

.assetsContainer .assetWrapper .actions {
  position: absolute;
  z-index: 99;
  top: 0;
  right: 0;
  display: none;

  .downloadLink {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button {
    border: none;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #f1f1f1;
    }
  }
}

.assetsContainer .assetWrapper:hover .actions {
  display: flex;
}

.assetsContainer .assetActive {
  padding: 5px 0;
  font-size: 10px;
  text-align: center;

  .pretty {
    margin-right: 0;
  }

  .icon {
    font-size: 10px !important;
    margin: -1px 0 0 0;
  }
}

.assetsContainer .assetActive >>> label {
  margin-left: 2px;
}

.assetsContainer .assetWrapper .button.is-small {
  padding: 0;
  height: 21px;
  width: 21px;
  border-radius: 0;
}

.assetsContainer .assetWrapper .button.is-small i {
  font-size: 10px;
}

.assetsContainer .assetWrapper.isActive {
  background-color: $themeColor1;
  border: 1px solid $themeColor1;
}

.assetsContainer .assetWrapper.isActive .assetOrigin,
.assetsContainer .assetWrapper.isActive .assetActive {
  transition: all 0.3s ease;
  color: #fff;
}

.assetsContainer .assetWrapper.isActive .assetActive i {
  transition: all 0.3s ease;
  color: #fff;
}

.assetsContainer .assetWrapper.isArchived .overlay {
  display: block;
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
